// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"afc1cb44","206":"2bb70f93","318":"a62e3a94","428":"53be5f43","473":"33c86567","932":"623aa1ef"}[chunkId] + ".chunk.css";
};